<template>
  <div class="collect-container" @click="handleClick">
    <img :src="sectionIcon" class="collect-icon" />
    <bi-button label="区间配置" type="text" />
  </div>
</template>

<script>
import sectionIcon from "@/assets/images/report/section.svg";

export default {
  name: "SectionCom",
  data() {
    return {
      sectionIcon,
    };
  },
  methods: {
    handleClick() {
      this.$emit("sectionClick");
    },
  },
};
</script>

<style lang="scss" scoped>
.collect-container {
  display: flex;
  align-items: end;
  cursor: pointer;
  .collect-icon {
    width: 20px;
    height: 20px;
    margin-right: 4px;
    transform: translateY(3px);
  }
}
</style>
